
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/watch-stream/video/[streamSlug]",
      function () {
        return require("private-next-pages/[athleteSlug]/watch-stream/video/[streamSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/watch-stream/video/[streamSlug]"])
      });
    }
  